if (!customElements.get('atc-bar')) {
  class AtcBar extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        atcButton: '.js-submit',
        option: '.js-option',
        mainAtc: '.js-add-btn',
        mainSetButton: '.js-add-set-btn',
        price: '.js-atc-bar-price',
      };
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      document.addEventListener('scroll', () =>
        this.handleVisibility()
      );
      window.addEventListener('load', () => this.handleVisibility());

      for (const optionSelect of this.querySelectorAll(
        this.selectors.option
      )) {
        optionSelect.addEventListener('change', (event) =>
          this.handleOptionChange(event.target)
        );
      }

      this.querySelector(this.selectors.atcButton)?.addEventListener(
        'click',
        (event) => this.handleSubmit(event)
      );

      document.addEventListener(
        'product-selector:change-variant',
        (event) => {
          const { name, value, available } = event.detail;
          this.changeOption(name, value);
          available ? this.enableButton() : this.disableButton();
        }
      );

      document.addEventListener(
        'product-selector:change-price',
        (event) => {
          const { finalPrice, comparePrice } = event.detail;
          this.changePrice(finalPrice, comparePrice);
        }
      );
    }

    show() {
      this.classList.add('is-visible');
      this.addBodyPadding();
    }

    hide() {
      this.classList.remove('is-visible');
      this.removeBodyPadding();
    }

    changeOption(name, value) {
      const targetSelect = this.querySelector(`select[name='${name}']`);
      targetSelect && (targetSelect.value = value);
    }

    changePrice(finalPrice, comparePrice) {
      const target = this.querySelector(this.selectors.price);
      target &&
        (target.innerHTML = `
        <span>${Shopify.formatMoney(
          finalPrice,
          Shopify.current_money_format
        )}</span>
        ${
          !!comparePrice
            ? `<s>${Shopify.formatMoney(
                comparePrice,
                Shopify.current_money_format
              )}</s>`
            : ''
        }
      `);
    }

    handleVisibility() {
      const elementToLookFor = document.querySelector(
        this.selectors.mainSetButton
      )
        ? document.querySelector(this.selectors.mainSetButton)
        : document.querySelector(this.selectors.mainAtc);

      isScrolledPastElement(elementToLookFor) ? this.show() : this.hide();
    }

    /**
     * Sync atc-bar options with main form options.
     *
     * @param {Node} select
     * @returns {Void}
     */
    handleOptionChange(select) {
      const form = document.querySelector(
        '.js-product product-selector, .js-product set-product-selector'
      )?.form;
      const inputEl = form?.querySelector(
        `[name="${select.getAttribute('name')}"][value="${
          select.value
        }"]`
      )?.nextElementSibling;

      if (!!inputEl) {
        inputEl.click();
        return;
      }

      const selectEl = form.querySelector(
        `[name="${select.getAttribute('name')}"]`
      );
      if (!!selectEl) {
        selectEl.value = select.value;
        selectEl.dispatchEvent(new Event('change'));
      }
    }

    // TODO event
    handleSubmit(event) {
      event.preventDefault();
      document
        .querySelector('product-selector')
        ?.submitButton.click();
    }

    addBodyPadding() {
      document.body.style.paddingBottom = `${this.scrollHeight}px`;
    }

    removeBodyPadding() {
      document.body.style.paddingBottom = '';
    }

    disableButton() {
      this.querySelector(this.selectors.atcButton)?.setAttribute('disabled', true);
    }

    enableButton() {
      this.querySelector(this.selectors.atcButton)?.removeAttribute('disabled');
    }
  }
  customElements.define('atc-bar', AtcBar);
}
